import { http, createConfig } from '@wagmi/core'
import { coinbaseWallet, metaMask } from '@wagmi/connectors'
import { polygon, polygonAmoy } from '@wagmi/core/chains'
import { environment } from 'src/environments/environment'
const supported_chains: any = environment.DEFAULT_NETWORK == "137" ? polygon : polygonAmoy 
const RPC_URL = (environment as any)[environment.DEFAULT_CHAIN].PROVIDER
export const wagmi_config = createConfig({
    chains: [supported_chains],
    transports: {
        [supported_chains.id]: http(RPC_URL),
    },
})